/* eslint-disable import/no-duplicates */
import "react-native-gesture-handler";
import "react-native-reanimated";

import { DarkTheme, DefaultTheme, ThemeProvider } from "@react-navigation/native";
import { Stack, useSegments } from "expo-router";
import { StatusBar } from "expo-status-bar";
import { Platform, StyleSheet, View, useWindowDimensions } from "react-native";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { SafeAreaProvider } from "react-native-safe-area-context";

import PublicBottomBar from "@/components/public/PublicBottomBar";
import SeoHead from "@/components/seo/SeoHead";
import { useColorScheme } from "@/hooks/use-color-scheme";
import {
  SEO_DEFAULT_IMAGE_URL,
  SEO_HOME_DESCRIPTION,
  SEO_HOME_TITLE,
} from "@/lib/seo";

export const unstable_settings = {
  anchor: "(tabs)",
};

const APP_BACKGROUND_COLOR = "#f8fafc";
const DESKTOP_WEB_MIN_WIDTH = 1024;

const webFixedViewportStyle =
  Platform.OS === "web"
    ? ({
        height: "var(--soko-viewport-height)",
        minHeight: "var(--soko-viewport-height)",
      } as any)
    : null;

const webScrollableViewportStyle =
  Platform.OS === "web"
    ? ({
        height: "auto",
        minHeight: "var(--soko-viewport-height)",
        flexBasis: "auto",
        flexShrink: 0,
      } as any)
    : null;

export default function RootLayout() {
  const colorScheme = useColorScheme();
  const { width } = useWindowDimensions();
  const segments = useSegments();
  // Owner screens need a bounded viewport for scrolling above their footers.
  const isOwnerRoute = segments[0] === "(owner)";
  const webViewportStyle =
    Platform.OS === "web" &&
    width >= DESKTOP_WEB_MIN_WIDTH &&
    !isOwnerRoute
      ? webScrollableViewportStyle
      : webFixedViewportStyle;

  return (
    <GestureHandlerRootView style={[styles.root, webViewportStyle]}>
      <SafeAreaProvider style={styles.safeAreaProvider}>
        <ThemeProvider value={colorScheme === "dark" ? DarkTheme : DefaultTheme}>
          <SeoHead
            title={SEO_HOME_TITLE}
            description={SEO_HOME_DESCRIPTION}
            imageUrl={SEO_DEFAULT_IMAGE_URL}
          />
          <View style={[styles.appShell, webViewportStyle]}>
            <Stack
              screenOptions={{
                headerShown: false,
                contentStyle: styles.stackContent,
              }}
            >
              <Stack.Screen name="(tabs)" />
              <Stack.Screen
                name="modal"
                options={{ presentation: "modal", title: "Modal", headerShown: true }}
              />
            </Stack>
            <PublicBottomBar />
          </View>
          <StatusBar style="auto" />
        </ThemeProvider>
      </SafeAreaProvider>
    </GestureHandlerRootView>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    minHeight: 0,
    backgroundColor: APP_BACKGROUND_COLOR,
  },
  safeAreaProvider: {
    flex: 1,
    minHeight: 0,
  },
  appShell: {
    flex: 1,
    minHeight: 0,
    backgroundColor: APP_BACKGROUND_COLOR,
  },
  stackContent: {
    flex: 1,
    minHeight: 0,
    backgroundColor: APP_BACKGROUND_COLOR,
  },
});
